import { Card } from "@repo/ping-design";
import cx from "classnames";

import "./SOVDataRelevanceCard.scss";

type SOVDataRelevanceCardProps = {
  children: React.ReactNode;
  className?: string;
};

const SOVDataRelevanceCard = ({
  children,
  className,
}: SOVDataRelevanceCardProps) => {
  return (
    <Card className={cx("SOVDataRelevanceCard", className)}>{children}</Card>
  );
};

export default SOVDataRelevanceCard;
